// extracted by mini-css-extract-plugin
module.exports = {"mainContainerSearcbar":"barra_mainContainerSearcbar__2QQYr","input":"barra_input__1DXAK","boton":"barra_boton__15SZZ","SearchIcon":"barra_SearchIcon__2lqXt"};